import { SolarModel } from 'src/Libs/solar/models/solar.model'
import { SolarOverviewDto } from 'src/Libs/solar/dto/solar-overview.dto'
import { fromDtoToModel } from 'src/Libs/solar/transformers'
import { useEffect, useState } from 'react'
import { mergePvSettings } from 'src/Libs/solar/utils'
import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { isUndefined } from 'lodash'

const SERVICE_ID = '[SOLAR HARDWARE]'

const DEFAULT_SETTINGS = {
  pviAcApparentPower: { count: 0, max: 0, min: 0, values: [] },
  pviAcCurrent: { count: 0, max: 0, min: 0, values: [] },
  pviAcPower: { count: 0, max: 0, min: 0, values: [] },
  pviAcReactivePower: { count: 0, max: 0, min: 0, values: [] },
  pviAcVoltage: { count: 0, max: 0, min: 0, values: [] },
  pviDcCurrent: { count: 0, max: 0, min: 0, values: [] },
  pviDcPower: { count: 0, max: 0, min: 0, values: [] },
  pviDcVoltage: { count: 0, max: 0, min: 0, values: [] },
  pviDeviceState: { pviDeviceConnected: false, pviDeviceInService: false, pviDeviceWorking: false },
  pviEnergyAll: [],
  pviIndex: 0,
  pviLastError: '',
  pviRotaryFieldDirection: 'left',
  pviSerialNumber: '',
  pviState: '',
  pviTemperature: { count: 0, max: 0, min: 0, values: [] },
  pviTracker: 0,
} as SolarModel

/**
 * This hook provides the utils for the Battery API through a websocket connection
 */
const useLiveSolar = (storageId: string | undefined, listIndex: string | undefined): SolarModel => {
  const [settings, setSettings] = useState<SolarModel>(DEFAULT_SETTINGS)
  const resourcePath = `storages/${storageId}/hardware/pv-inverter/overview/${listIndex}/ws`
  const { socketState } = useWebSocketApi<SolarModel, SolarOverviewDto>({
    apiResourcePath: resourcePath,
    loggerKey: SERVICE_ID,
    transformer: fromDtoToModel,
    doNotInitialize: isUndefined(storageId) || isUndefined(listIndex) || isNaN(parseInt(listIndex)),
    endpoint: process.env.REACT_APP_API_ENDPOINT ?? '',
  })

  useEffect(() => {
    if (socketState.data) {
      const mutated = mergePvSettings(socketState.data, DEFAULT_SETTINGS)
      setSettings(mutated)
    }
  }, [socketState.data])

  return settings
}

export default useLiveSolar
